import styled from "styled-components";
import { Navigation } from "swiper";
import { useIntl } from "react-intl";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import FeatureProcesses from "../../../../components/FeatureProcesses";
import Image from "../../../../components/Image";
import { useRef, forwardRef, useImperativeHandle } from "react";
import Attributes from "../../../../components/Attributes";
export default forwardRef(CSwiper);
function CSwiper({ list = [], footerRender = () => {} }, ref) {
  const swiper = useRef();
  const intl = useIntl();
  useImperativeHandle(ref, () => {
    return {
      getSwiper: () => {
        return swiper.current;
      },
    };
  });
  return (
    <SwiperContainer>
      <Swiper
        observer={true}
        modules={[Navigation]}
        spaceBetween={10}
        slidesPerView={1}
        onSwiper={(s) => {
          swiper.current = s;
        }}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
      >
        {list.map((e, i) => (
          <SwiperSlide key={e.id || i}>
            <EquipName>
              <span>
                {new Array((e && e.equip && e.equip.level) || 0)
                  .fill("")
                  .map((e, i) => (
                    <img key={i} src="/image/foot.png" width={8} alt="foot" />
                  ))}{" "}
                {e.name || "Level"}
              </span>
            </EquipName>

            {footerRender(e)}
            <div
              style={{
                display: "inline-block",
                height: "12.0rem",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Image
                fit="contain"
                className={"equips_img " + (e.img ? "active" : "")}
                src={e.goodImg || e.img || "/image/question_mark.png"}
                alt={"equips_img"}
              ></Image>
            </div>

            {e.id ? (
              <div className="text-center">
                <Code>
                  <I src="/image/codeIndex.png" />
                  {e.id}
                </Code>
              </div>
            ) : null}
            <Attributes equip={e.equip} intlfn={intl} />
            <FeatureProcesses
              intlfn={intl}
              specialty={e.equip ? e.equip.specialty : 0}
              aesthetic={e.equip ? e.equip.aesthetic : 0}
              comfort={e.equip ? e.equip.comfort : 0}
              resilence={e.equip ? e.equip.resilence : 0}
            />
          </SwiperSlide>
        ))}
        <div className="swiper-button-prev">
          <img src="/image/left_arrow.png" width={25} alt="left_arrow" />
        </div>
        <div className="swiper-button-next">
          <img src="/image/right_arrow.png" width={25} alt="right_arrow" />
        </div>
      </Swiper>
    </SwiperContainer>
  );
}

const SwiperContainer = styled.div`
  .swiper {
    width: 100%;

    position: relative;
    .swiper-button-prev {
      left: 1.0rem;
      right: auto;
      position: absolute;
      top: 8.1rem;
      z-index: 10;
      transform: translateY(-50%);
    }
    .swiper-button-next {
      right: 1.0rem;
      left: auto;
      position: absolute;
      top: 8.1rem;
      z-index: 10;
      transform: translateY(-50%);
    }
    .swiper-button-disabled {
      opacity: 0.5;
    }
    .swiper-slide {
      padding: 3.0rem 0 0;
    }
  }
`;

const EquipName = styled.div`
  background: #f4f5f6;
  border-radius: .0rem .0rem 1.3rem 1.3rem;
  text-align: center;
  width: 14.6rem;
  margin: auto;
  padding: .5rem 0 .8rem;
  font-style: normal;
  font-weight: 500;
  font-size: 1.3rem;
  line-height: 1.2rem;
  position: absolute;
  color: #000000;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
`;

const Code = styled.div`
  font-family: "Anybody";
  font-style: italic;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: ${(props) => (props.mounted ? "#FC9043" : "#000000")};
  border: 1px solid ${(props) => (props.mounted ? "#FC9043" : "#000000")};
  border-radius: 1.9rem;
  min-width: 10.0rem;
  padding: 2px 1px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  box-shadow: .05rem .05rem .0rem
    ${(props) => (props.mounted ? "#FC9043" : "#000000")};
`;

const I = styled.img`
  width: 1.4rem;
  height: 1.4rem;
  margin-right: .3rem;
`;
